module.exports = __webpack_public_path__ + "0673d56e7e97a6b90dd591beffea5e4a.png";